import { useState } from "react";
import {
  getMileageMember,
  getPubMemberList,
  PubMemberDto,
} from "../../../../api/member";
import { SearchBox } from "../../style/popup";
import { SearchMemberWrapper, SearchListWrapper } from "../mileage/style";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../recoil/pub.atom";

interface SearchMemberProps {
  setSelectMember: (value: PubMemberDto | null) => void;
  selectMember: PubMemberDto | null;
  type?: string;
}
const SearchMember = ({
  setSelectMember,
  selectMember,
  type,
}: SearchMemberProps) => {
  const pub = useRecoilValue(pubState);
  const [search, setSearch] = useState<string>("");
  const [searchList, setSearchList] = useState<PubMemberDto[]>([]);
  const [isSearchEnd, setIsSearchEnd] = useState<boolean>(false);

  const handleSearch = async () => {
    if (!pub) return;
    if (!search) {
      alert("닉네임을 입력해주세요. ");
      return;
    }
    try {
      const res =
        type === "MILEAGE"
          ? await getMileageMember(search, pub.id)
          : await getPubMemberList(search, pub.id);
      setIsSearchEnd(true);
      setSearchList(res.memberList);
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        alert("검색한 닉네임을 찾을 수 없습니다.");
      } else {
        alert("에러가 발생했습니다. 다시 시도해주세요.");
      }
      return;
    }
  };

  const handleSelectMember = (item: PubMemberDto | null) => {
    setSelectMember(item);
    setIsSearchEnd(false);
    setSearch("");
  };

  return (
    <SearchMemberWrapper>
      <SearchBox>
        {selectMember && (
          <div className="member">
            {selectMember.nickname}
            <img
              src="/image-web/solution/search-delete.svg"
              alt="delete"
              onClick={() => handleSelectMember(null)}
            />
          </div>
        )}
        <input
          type="text"
          placeholder={!selectMember ? "닉네임을 검색하세요. " : ""}
          value={search}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              handleSearch();
            }
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="searchIcon" onClick={() => handleSearch()}>
          <img src="/image-web/timer-config/searchIcon.svg" alt="검색 아이콘" />
        </div>
      </SearchBox>
      {isSearchEnd && (
        <SearchListWrapper>
          {searchList.length === 0 ? (
            <div className="no-data">검색 결과가 없습니다. </div>
          ) : (
            searchList.map((item, index) => (
              <div
                className="item"
                key={index}
                onClick={() => handleSelectMember(item)}
              >
                <div className="nick">{item.nickname}</div>
              </div>
            ))
          )}
        </SearchListWrapper>
      )}
    </SearchMemberWrapper>
  );
};

export default SearchMember;
